import { IonContent, IonInput, IonPage, IonText, IonTextarea,IonIcon } from "@ionic/react"
import Head from "./Header";
import Sidebar from "./Sidebar";
import { useState,useEffect } from "react";
import { useHistory } from "react-router";
import swal from 'sweetalert';
import service from "../Service/service";
import Select from 'react-select';
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const LeaveBatchUpdate = () => {
      const history = useHistory();
      const [Emptype,setemptype]=useState('')
      const [Id] = useState(localStorage.getItem("SignupEmpId"));
      useEffect(() => {
          if (Id === null) {
            history.push("/login");
          } else {
          }
        }, [Id, history]);

      const [month, setMonth] = useState("");

      const [createBy] = useState(localStorage.getItem("SignupEmpId"));

      const getMonth = (e: any) => {
            let date = (e.target.value).split('-');
            let month = date[1];

            const d = new Date();
            d.setMonth(month - 1);
            const monthName1 = d.toLocaleString("default", { month: "long" });
            console.log(monthName1, "month");
            setMonth(monthName1 + " " + date[0]);
      }

      const Update = () => {
            if (month === "") {
                  swal("", "Please Select Month & Year", "info")
            }
            else {
                  service.LeaveBatchUpdate(month, createBy)
                        .then((response) => {
                              console.log(response)
                              if (response.data.status === 200) {
                                    swal("", "Updated Successfully", "success")
                              }
                              else {
                                    swal("", response.data.Message, "info")
                              }
                        })
                        .catch((error) => {
                              console.log(error)
                        })
            }
      }
      const back = () => {
            history.goBack();
        }

        const EmpType = [
            { value: 1, label: 'Contract' },
            { value: 2, label: 'Permanent' },
        ]
        const [selectedOption, setSelectedOption] = useState(null);
        const [inputValue, setInputValue] = useState('');
        const [isFocused, setIsFocused] = useState(false);
        const [menuIsOpen, setMenuIsOpen] = useState(false);
        
    
        const handleStateChange = (selectedOption: any) => {
            setSelectedOption(selectedOption);
        };
    
        const handleInputChange = (inputValue: any) => {
            setInputValue(inputValue);
        };
    
        const handleMenuOpen = () => {
            setMenuIsOpen(true);
        };
    
        const handleMenuClose = () => {
            setMenuIsOpen(false);
        };
    
        const handleFocus= () => {
            setIsFocused(true);
        };
    
        const handleBlur = () => {
            setIsFocused(false);
        };
    
        const Placeholder = () => {
            if (inputValue === '' && !selectedOption && !isFocused) {
                return <span style={{ color: "black" }}>Select Type</span>;
            } else {
                return <span style={{ color: "black" }}>Type to Search Here...</span>;
            }
        };
    
        const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
            const [isClicked, setIsClicked] = useState(false);
    
            useEffect(() => {
                if (isClicked && !selectProps.menuIsOpen9) {
                    setIsClicked(false);
                }
            }, [selectProps.menuIsOpen9]);
    
            let icon;
            if (isClicked || selectProps.menuIsOpen) {
                icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
            } else {
                icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
            }
    
            const handleIconClick = () => {
                setIsClicked(true);
            };
    
            return (
                <div {...innerProps}>
                    <div onClick={handleIconClick}>{icon}</div>
                </div>
            );
        };
    
        const list = (selectedOption: any) => {
            setemptype(selectedOption.value);
        };
    
      return (
            <IonPage>
                  <Head />
                  <Sidebar />
                  <IonContent>
                        <div className="page-wrapper">
                              <div className="page-header">
                                    <div className="content container-fluid">
                                          <div className="row align-items-center">
                                                <div className="col">
                                                      <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                                      <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />   Leave Update </h3>
                                                </div>
                                          </div>
                                          <div className="row filter-row" style={{ marginTop: "3%" }}>
                                                <div className="col-sm-6 col-md-4">
                                                      <div className="form-group">
                                                            <label style={{ fontWeight: "bold" }}> Month & Year <span className="text-danger">*</span></label>
                                                            <div>
                                                                  <IonInput type="month" onIonChange={(e: any) => getMonth(e)} className="form-control datetimepicker" />
                                                            </div>
                                                      </div>
                                                </div>
                                                <div className="col-sm-6 col-md-4">
                                                      <div className="form-group">
                                                            <label style={{ fontWeight: "bold" }}> Employment Type <span className="text-danger">*</span></label>
                                                            <Select
                                            options={EmpType}
                                            value={EmpType.find((option: any) => option.value === Emptype) || null}
                                            onChange={list}
                                            onInputChange={handleInputChange}
                                            onMenuOpen={handleMenuOpen}
                                            onMenuClose={handleMenuClose}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            menuIsOpen={menuIsOpen}
                                            isSearchable

                                            placeholder={<Placeholder />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator,
                                            }}
                                            className="custom-select0"
                                        />
                                                      </div>
                                                </div>
                                                <div className="col-sm-6 col-md-4" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                                      <a onClick={() => Update()} className="btn btn-success btn-block w-100"> Update </a>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </IonContent>
            </IonPage>
      )
}

export default LeaveBatchUpdate;